import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import { getLongestUploadDurationReport } from "../../../features/reports/reportSlice"
import moment from "moment"
import Pagination from "../../shared/Pagination"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .title-list{
                display:grid;
                grid-template-columns: repeat(5, 1fr);
                width: 100%;
                gap: 20px;
                text-align: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
            }
            .main-side{
                text-align: center;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                padding-bottom: 20px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                .info{
                    display:grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 20px;
                    .text{
                        text-align: center;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }

            .average{
                display: flex;
                align-items: center;
                gap: 5px;
                margin-top: 20px;
                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }
                span{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 20px;
        }
    }
    .red{
        color: var(--color-main);
    }
    .green{
        color: var(--color-green);
    }
`

const titles = ["Sıra", "Kaydeden Firma", "Gönderici Adı/Ünvanı", "Süre (Saat)", "Yükleme Tarihi"]

const EnUzunSureliYuklemeModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const { longestLoadReport, longestLoadReportCount } = useSelector(state => state.report)
    const itemsPerPage = 10;
    const totalPages = Math.ceil(longestLoadReportCount / itemsPerPage);
    const [currentPage, setCurrentPage] = useState(0);

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getLongestUploadDurationReport(currentPage))
    }, [currentPage])
    

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"En Uzun Süreli Yüklemeler Raporu"}/>
            <div className="content">
                
                <div className="title-list">
                    {titles.map((item) => (
                        <div className="title">{item}</div>
                    ))}
                </div>
                <div className="main-side">
                    {longestLoadReport?.[0]?.longestOffloadRecords?.$values?.map((item, i) => {
                        const index = i + 1
                        const underAverage = item?.duration < longestLoadReport?.[0]?.averageUploadDuration
                        return (
                            <div className="info">
                                <div className="text">{index}</div>
                                <div className="text">{item?.registeredCompany}</div>
                                <div className="text">{item?.receiverNameTitle}</div>
                                <div className={`text ${underAverage ? "green" : "red"}`}>{item?.duration?.toFixed(1)}</div>
                                <div className="text">{moment(item?.uploadDate).format('L')}</div>
                            </div>
                        )
                    })}
                </div>
                <div className="average">
                    <p>Ortalama Yükleme Süresi: </p>
                    <span>{longestLoadReport?.[0]?.averageUploadDuration?.toFixed(1)} saat</span>
                </div>
            </div>
            <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>

            <div className='button-grp'>
                <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </ModalContainer>
  )
}

export default EnUzunSureliYuklemeModal